import styled from '@emotion/styled'

import { DOCUMENT_HTML_PREVIEW_IFRAME_MIN_WIDTH } from '@features/invoices/constants/documentHtmlPreviewDimensions'

export const InvoiceHtmlPreviewWrapper = styled.div`
  min-width: ${DOCUMENT_HTML_PREVIEW_IFRAME_MIN_WIDTH}px;
  position: relative;
  background-color: transparent;
`
